<!--
  SdAllocationHistory.vue  —  SD Time Allocation feature (design doc EMP_SD_Time_Allocation_Design_v0.1, D5)
  NEW component. Target location: web/src/views/apps/campaigns/SdAllocationHistory.vue
  Renders the allocation audit trail for one campaign:
  when · who changed it · which SD · old -> new · note.

  Props:
    campaignId (required) — the campaign whose history to fetch.

  Requires the campaignsManagement store module to be registered by the hosting page
  (true for Statistics.vue and CampaignEdit.vue, which both register it in created()).

  API: GET /api/campaigns/sd_allocation_history/<campaignId>
       -> [{changed_at, changed_by_name, sales_developer_name, old_hours, new_hours, note}]
-->
<template>
  <div class="sd-allocation-history">
    <vs-row vs-w="12" class="mt-1">
      <h5><u class="p-1">SD Allocation History</u></h5>
    </vs-row>
    <vs-row vs-w="12" class="mt-1">
      <span v-if="loading" class="text-sm">Loading allocation history…</span>
      <span v-else-if="loadError" class="text-sm" style="color: #EA5455;">{{ loadError }}</span>
      <span v-else-if="history.length === 0" class="text-sm">No allocation changes recorded for this campaign.</span>
      <vs-table v-else class="mb-10" :data="history">
        <template slot="thead">
          <vs-th>When</vs-th>
          <vs-th>Changed By</vs-th>
          <vs-th>Sales Developer</vs-th>
          <vs-th>Old &rarr; New</vs-th>
          <vs-th>Note</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].created_at">
              {{ formatWhen(data[indextr].created_at) }}
            </vs-td>
            <vs-td :data="data[indextr].changed_by_name">
              {{ data[indextr].changed_by_name }}
            </vs-td>
            <vs-td :data="data[indextr].sales_developer_name">
              {{ data[indextr].sales_developer_name }}
            </vs-td>
            <vs-td :data="data[indextr].new_hours">
              {{ formatHours(data[indextr].old_hours) }} &rarr; {{ formatHours(data[indextr].new_hours) }}
            </vs-td>
            <vs-td :data="data[indextr].note">
              {{ data[indextr].note }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-row>
  </div>
</template>

<script>
import moment from "moment";

var HOURS_PER_DAY = 7;

export default {
  name: "SdAllocationHistory",
  props: {
    campaignId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      history: [],
      loading: false,
      loadError: null
    };
  },
  watch: {
    campaignId() {
      this.fetchHistory();
    }
  },
  mounted() {
    this.fetchHistory();
  },
  methods: {
    formatWhen(value) {
      if (!value) return "-";
      var m = moment(value);
      return m.isValid() ? m.format("DD/MM/YYYY HH:mm") : String(value);
    },
    formatHours(hours) {
      if (hours === null || hours === undefined || hours === "") return "—";
      var n = parseFloat(hours);
      if (isNaN(n)) return String(hours);
      var days = (Math.round((n / HOURS_PER_DAY) * 100) / 100).toFixed(2).replace(/\.00$/, "");
      return n + " h (" + days + " d)";
    },
    fetchHistory() {
      var self = this;
      if (this.campaignId == null || this.campaignId === "") return;
      this.loading = true;
      this.loadError = null;
      this.$store
        .dispatch("campaignsManagement/getSdAllocationHistory", this.campaignId)
        .then(function (res) {
          self.loading = false;
          self.history = res.data.data || [];
        })
        .catch(function (err) {
          self.loading = false;
          self.loadError = "Could not load allocation history.";
          if (err && err.response && err.response.status === 401) {
            self.$router.replace("/login");
          }
        });
    }
  }
};
</script>

<style scoped>
.sd-allocation-history .text-sm {
  font-size: 0.85rem;
}
</style>
